import apiClient from 'api/apiClient';
import API_END_POINT from 'constants/apiEndPoints';
import { ApiResponse } from 'types';

interface FetchFrameworkResponse extends ApiResponse {
  frameworks: {
    [frameworkName: string]: string[];
  };
}

type FetchFramework = () => Promise<FetchFrameworkResponse>;

const fetchFrameworks: FetchFramework = async () => {
  const { data } = await apiClient.get(API_END_POINT.BLOCK.FETCH_FRAMEWORKS);

  const resultData = data as FetchFrameworkResponse;
  if (resultData.result) {
    resultData.frameworks = {
      PyTorch: [...resultData.frameworks['pyTorch']],
    };

    return resultData;
  }

  return data;
};

export default fetchFrameworks;
